module.exports = __webpack_public_path__ + "img/banner-r-l.8b418af2.png";